<ng-container *ngIf="isWarningVisible">
  <app-content-row>
    <app-alert-box type="warning">
      <div>掲載が終了したセットは、リストから自動的に削除されます。</div>
    </app-alert-box>
  </app-content-row>
</ng-container>
